import React from "react";
export const FormBuilderFormHint = ({ item, id }) => {
  return /* @__PURE__ */ React.createElement("p", { id, className: "div-hint" }, item);
};
